var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "list-dropdown",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.36,
    height: 29.36,
    viewBox: "0 0 29.36 29.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M28.166,7.194V3H3V13.486h9.437V32.36H32.36V7.194ZM5.1,11.389V5.1H26.068v2.1H12.437v4.194ZM30.263,30.263H14.534V9.291H30.263Z",
    transform: "translate(-3 -3)",
    fill: "#00828b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22.5,16.5h2.1v2.1H22.5Z",
    transform: "translate(-8.869 -7.063)",
    fill: "#00828b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M28.5,16.5h7.34v2.1H28.5Z",
    transform: "translate(-10.674 -7.063)",
    fill: "#00828b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M22.5,25.5h2.1v2.1H22.5Z",
    transform: "translate(-8.869 -9.772)",
    fill: "#00828b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M28.5,25.5h7.34v2.1H28.5Z",
    transform: "translate(-10.674 -9.772)",
    fill: "#00828b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M22.5,34.5h2.1v2.1H22.5Z",
    transform: "translate(-8.869 -12.48)",
    fill: "#00828b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M28.5,34.5h7.34v2.1H28.5Z",
    transform: "translate(-10.674 -12.48)",
    fill: "#00828b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDropdown);
export default __webpack_public_path__ + "static/media/list-dropdown.87a4157d76fa11951937e23beb347432.svg";
export { ForwardRef as ReactComponent };